var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#3299FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4089 5.60893C12.3638 5.50033 12.2775 5.41403 12.1689 5.36893C12.1155 5.34616 12.0581 5.33408 12 5.33337H9.77778C9.6599 5.33337 9.54686 5.3802 9.46351 5.46355C9.38016 5.5469 9.33333 5.65994 9.33333 5.77782C9.33333 5.89569 9.38016 6.00874 9.46351 6.09209C9.54686 6.17544 9.6599 6.22226 9.77778 6.22226H10.9289L8.44444 8.70671L6.98222 7.24004C6.94091 7.19838 6.89175 7.16532 6.83759 7.14276C6.78343 7.12019 6.72534 7.10857 6.66667 7.10857C6.60799 7.10857 6.5499 7.12019 6.49574 7.14276C6.44158 7.16532 6.39243 7.19838 6.35111 7.24004L3.68444 9.90671C3.64279 9.94802 3.60972 9.99718 3.58716 10.0513C3.5646 10.1055 3.55298 10.1636 3.55298 10.2223C3.55298 10.2809 3.5646 10.339 3.58716 10.3932C3.60972 10.4473 3.64279 10.4965 3.68444 10.5378C3.72576 10.5795 3.77492 10.6125 3.82908 10.6351C3.88324 10.6577 3.94133 10.6693 4 10.6693C4.05867 10.6693 4.11676 10.6577 4.17092 10.6351C4.22508 10.6125 4.27424 10.5795 4.31556 10.5378L6.66667 8.18226L8.12889 9.64893C8.17021 9.69059 8.21936 9.72365 8.27352 9.74621C8.32768 9.76878 8.38577 9.7804 8.44444 9.7804C8.50312 9.7804 8.56121 9.76878 8.61537 9.74621C8.66953 9.72365 8.71868 9.69059 8.76 9.64893L11.5556 6.84893V8.00004C11.5556 8.11791 11.6024 8.23096 11.6857 8.31431C11.7691 8.39766 11.8821 8.44448 12 8.44448C12.1179 8.44448 12.2309 8.39766 12.3143 8.31431C12.3976 8.23096 12.4444 8.11791 12.4444 8.00004V5.77782C12.4437 5.71974 12.4317 5.66236 12.4089 5.60893Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp);
export default __webpack_public_path__ + "static/media/trendUp.ef479bce4473c51af3802ba3074df601.svg";
export { ForwardRef as ReactComponent };